module.exports = __webpack_public_path__ + "static/indica_icon-6817293117b25d7a5617bb5cc786c683.svg";